import React from 'react';
import { Box, FormControl, Typography, Select, MenuItem } from '@mui/material';

import RequiredMarker from '../requiredMarker';

const StatusSelect = ({ statuses, selectedStatus, setSelectedStatus }) => {
    const [hasInteracted, setHasInteracted] = React.useState(false);

    React.useEffect(
        () => () => {
            //unmount
            setHasInteracted(false);
            setSelectedStatus('');
        },
        []
    );

    return (
        <Box
            sx={{
                marginTop: (theme) => theme.spacing(3),
                maxWidth: '50%',
            }}
        >
            <FormControl
                fullWidth
                error={hasInteracted && selectedStatus === ''}
                size="small"
            >
                <Typography>
                    <RequiredMarker />
                    &nbsp; Status:
                </Typography>
                <Select
                    id="status-select"
                    onChange={(e) => setSelectedStatus(e.target.value)}
                    onClick={() => setHasInteracted(true)}
                    value={selectedStatus}
                >
                    <MenuItem
                        value={''}
                        sx={{ height: 36 }}
                    ></MenuItem>
                    {statuses.map((statusObj) => (
                        <MenuItem value={statusObj.StatusID}>{statusObj.Description}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default StatusSelect;
